import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=44d4f32b&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d4f32b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44d4f32b')) {
      api.createRecord('44d4f32b', component.options)
    } else {
      api.reload('44d4f32b', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=44d4f32b&scoped=true&", function () {
      api.rerender('44d4f32b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/ticket2/ticket/Edit.vue"
export default component.exports